export const experienceData = [
  {
    title: "Software Engineering Intern",
    date: "Octomber 2020 - April 2021",
    subTitle: "Mitra Innovations, Sri Lanka",
    details:
      "Development of an Android/IOS application for a telecommunication client based in Cambodia. Completed the front-end of Card-Linking, Home Screen Revamp, Scheduler Top-up and few other features."
  },
  {
    title: "Creative Designer",
    date: "April 2018 - April 2019",
    subTitle: "Ikon, Sri Lanka",
    details:
      "Designed marketing campaigns for several leading brands in Sri Lanka. Created Artworks/videos to build brand awareness."
  }
];
